import React from 'react';
import { useLocale } from '../context/LocaleContext.jsx';

/** English/العربية toggle. Deliberately one click — language is not a setting
 *  buried in a preferences page for a bilingual newsroom. */
export default function LanguageSwitcher() {
  const { locale, setLocale, t } = useLocale();
  return (
    // A quiet text toggle. As a hot-pink segmented control it was the loudest
    // thing in the top bar, on every screen, for a choice made once a session.
    <div className="lang-switch" role="group" aria-label={t('common.language')}>
      <button
        type="button"
        className={`lang-switch__opt ${locale === 'en' ? 'is-active' : ''}`}
        aria-pressed={locale === 'en'}
        onClick={() => setLocale('en')}
        lang="en"
      >
        EN
      </button>
      <span className="lang-switch__sep" aria-hidden="true">/</span>
      <button
        type="button"
        className={`lang-switch__opt ${locale === 'ar' ? 'is-active' : ''}`}
        aria-pressed={locale === 'ar'}
        onClick={() => setLocale('ar')}
        lang="ar"
      >
        عربي
      </button>
    </div>
  );
}
